import { BackendModel } from "../../core/backend.service";

export class ProveedorSimple extends BackendModel{
  
    id: number;
    razonSocial: string;  
    
  }


// WEBPACK FOOTER //
// ./src/app/productos/modificacion-precio/proovedor-simple.model.ts